import { render, staticRenderFns } from "./share-post-button.vue?vue&type=template&id=e0744754&"
import script from "./share-post-button.vue?vue&type=script&lang=js&"
export * from "./share-post-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports